<template>
  <div class="mt-2">
    <label for="nationality-selector" class="block text-sm font-medium text-gray-700">Nacionalidad</label>
    <a-select
      id="nationality-selector"
      :default-value="internalValue"
      @change="onUpdate"
      class="mt-1 block w-full"
      placeholder="Selecciona una nacionalidad"
      show-search
      option-filter-prop="label"
      :filter-option="filterOption"
    >
      <a-select-option v-for="(nationality, index) in nationalities" :key="index" :value="nationality.code" :label="nationality.name">
        {{ nationality.icon }} {{ nationality.name }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Object,
      default: () => ({ code: '', name: '', icon: '' })
    }
  },
  computed: {
    internalValue () {
      return this.value.code || null
    }
  },
  data () {
    return {
      nationalities: [
        // América del Norte
        { code: 'us', name: 'Estadounidense', icon: '🇺🇸' },
        { code: 'ca', name: 'Canadiense', icon: '🇨🇦' },
        { code: 'mx', name: 'Mexicano', icon: '🇲🇽' },

        // América Central y el Caribe
        { code: 'gt', name: 'Guatemalteco', icon: '🇬🇹' },
        { code: 'hn', name: 'Hondureño', icon: '🇭🇳' },
        { code: 'sv', name: 'Salvadoreño', icon: '🇸🇻' },
        { code: 'ni', name: 'Nicaragüense', icon: '🇳🇮' },
        { code: 'cr', name: 'Costarricense', icon: '🇨🇷' },
        { code: 'pa', name: 'Panameño', icon: '🇵🇦' },
        { code: 'do', name: 'Dominicano', icon: '🇩🇴' },
        { code: 'cu', name: 'Cubano', icon: '🇨🇺' },
        { code: 'jm', name: 'Jamaicano', icon: '🇯🇲' },

        // América del Sur
        { code: 'ar', name: 'Argentino', icon: '🇦🇷' },
        { code: 'br', name: 'Brasileño', icon: '🇧🇷' },
        { code: 'cl', name: 'Chileno', icon: '🇨🇱' },
        { code: 'co', name: 'Colombiano', icon: '🇨🇴' },
        { code: 'pe', name: 'Peruano', icon: '🇵🇪' },
        { code: 've', name: 'Venezolano', icon: '🇻🇪' },
        { code: 'uy', name: 'Uruguayo', icon: '🇺🇾' },
        { code: 'bo', name: 'Boliviano', icon: '🇧🇴' },
        { code: 'py', name: 'Paraguayo', icon: '🇵🇾' },
        { code: 'ec', name: 'Ecuatoriano', icon: '🇪🇨' },

        // Europa
        { code: 'es', name: 'Español', icon: '🇪🇸' },
        { code: 'fr', name: 'Francés', icon: '🇫🇷' },
        { code: 'it', name: 'Italiano', icon: '🇮🇹' },
        { code: 'uk', name: 'Británico', icon: '🇬🇧' },
        { code: 'de', name: 'Alemán', icon: '🇩🇪' },
        { code: 'pt', name: 'Portugués', icon: '🇵🇹' },
        { code: 'nl', name: 'Holandés', icon: '🇳🇱' },
        { code: 'be', name: 'Belga', icon: '🇧🇪' },
        { code: 'se', name: 'Sueco', icon: '🇸🇪' },
        { code: 'no', name: 'Noruego', icon: '🇳🇴' },
        { code: 'dk', name: 'Danés', icon: '🇩🇰' },
        { code: 'fi', name: 'Finlandés', icon: '🇫🇮' },
        { code: 'ch', name: 'Suizo', icon: '🇨🇭' },
        { code: 'at', name: 'Austriaco', icon: '🇦🇹' },
        { code: 'gr', name: 'Griego', icon: '🇬🇷' },
        { code: 'pl', name: 'Polaco', icon: '🇵🇱' },
        { code: 'ru', name: 'Ruso', icon: '🇷🇺' },
        { code: 'ie', name: 'Irlandés', icon: '🇮🇪' },
        { code: 'cz', name: 'Checo', icon: '🇨🇿' },
        { code: 'ee', name: 'Estonio', icon: '🇪🇪' },
        { code: 'hu', name: 'Húngaro', icon: '🇭🇺' },

        // Asia
        { code: 'cn', name: 'Chino', icon: '🇨🇳' },
        { code: 'jp', name: 'Japonés', icon: '🇯🇵' },
        { code: 'kr', name: 'Coreano', icon: '🇰🇷' },
        { code: 'in', name: 'Indio', icon: '🇮🇳' },
        { code: 'il', name: 'Israelí', icon: '🇮🇱' },
        { code: 'th', name: 'Tailandés', icon: '🇹🇭' },
        { code: 'vn', name: 'Vietnamita', icon: '🇻🇳' },
        { code: 'ph', name: 'Filipino', icon: '🇵🇭' },
        { code: 'sg', name: 'Singapurense', icon: '🇸🇬' },
        { code: 'my', name: 'Malayo', icon: '🇲🇾' },
        { code: 'id', name: 'Indonesio', icon: '🇮🇩' },
        { code: 'lk', name: 'Sri Lankés', icon: '🇱🇰' },
        { code: 'pk', name: 'Pakistaní', icon: '🇵🇰' },
        { code: 'bd', name: 'Bangladesí', icon: '🇧🇩' },
        { code: 'mn', name: 'Mongol', icon: '🇲🇳' },
        { code: 'kh', name: 'Camboyano', icon: '🇰🇭' }
      ]
    }
  },
  methods: {
    onUpdate (value) {
      const selectedRecord = this.nationalities.find(record => record.code === value)
      selectedRecord.nameIcon = selectedRecord.icon + ' ' + selectedRecord.name
      this.$emit('change', selectedRecord)
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>

<style scoped>
/* Puedes añadir estilos adicionales aquí si es necesario */
</style>
